import { EventCatalogFromKeys } from "../types";

import { AdminEventCatalog, AdminEventKeys } from "./admin";
import { AppEventCatalog, AppEventKeys } from "./app";
import { AuthEventCatalog, AuthEventKeys } from "./auth";
import { DocsEventCatalog, DocsEventKeys } from "./docs";
import { FormsEventCatalog, FormsEventKeys } from "./forms";
import { GenericEventCatalog, GenericEventKeys } from "./generic";
import { LayoutEventCatalog, LayoutEventKeys } from "./layout";
import { OfferEventCatalog, OfferEventKeys } from "./offers";
import { OrgEventCatalog, OrgEventKeys } from "./org";
import { PublicEventCatalog, PublicEventKeys } from "./public";
import { VolunteerEventCatalog, VolunteerEventKeys } from "./volunteer";

export const EventKeys = {
  ...AdminEventKeys,
  ...AuthEventKeys,
  ...GenericEventKeys,
  ...OfferEventKeys,
  ...PublicEventKeys,
  ...OrgEventKeys,
  ...VolunteerEventKeys,
  ...AppEventKeys,
  ...DocsEventKeys,
  ...FormsEventKeys,
  ...LayoutEventKeys,
} as const;

export const EventCatalog: EventCatalogFromKeys<typeof EventKeys> = {
  ...AdminEventCatalog,
  ...GenericEventCatalog,
  ...OfferEventCatalog,
  ...PublicEventCatalog,
  ...OrgEventCatalog,
  ...VolunteerEventCatalog,
  ...AppEventCatalog,
  ...DocsEventCatalog,
  ...FormsEventCatalog,
  ...LayoutEventCatalog,
  ...AuthEventCatalog,
};

export type EventKeyValues = (typeof EventKeys)[keyof typeof EventKeys];
